function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(86.225 332)"
}, "0"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.9 282H705"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(70.235 285.315)"
}, "200"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.9 235.2H705"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(69.026 238.63)"
}, "400"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.9 188.4H705"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(69.702 191.946)"
}, "600"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.9 141.6H705"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(69.326 145.26)"
}, "800"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.9 94.8H705"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(61.565 98.576)"
}, "1,000"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.9 48H705"
}), React.createElement("text", {
  transform: "translate(12.382 11.207)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Congestion "), React.createElement("tspan", {
  x: 20.7,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Cost Per "), React.createElement("tspan", {
  x: -13,
  y: 31.2,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Commuter ($)")), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M114.4 1H705v327.5H114.4z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(114.387 355.752)"
}, "1982"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(234.826 355.752)"
}, "1990"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(401.547 355.752)"
}, "2000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(572.259 355.752)"
}, "2010"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(676.154 355.753)"
}, "2017"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M249.4 1v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M418.1 1v327.5"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M586.9 1v327.5"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Lines",
  fill: "none",
  strokeLinecap: "round"
}, React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.867,
  d: "M115 128.5l16.8-5.4 16.8-9.4 16.9 9.4 16.8 8.4 16.8 13.3 16.8 9.6 16.9 4 16.8 4.9 16.8.5 16.8 1.6 16.9-.9 16.8-3.5 16.8-5.4 16.8-3.5 16.9-5.6 16.8-5.4 16.8-6.8 16.8-4.4L435 114l16.8-10.8 16.8-8.9 16.8-1.4 16.9-6.8 16.8-2.6 16.8 4.2 16.8 6.6 16.9-12.6 16.8-2.6 16.8-8.4L620 47.3l16.9-12.2 16.8-7.7 16.8-7 16.8-7.7 16.9-5.8"
}), React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.867,
  d: "M115 180l16.8-9.6 16.8-14.3 16.9 11.2 16.8 6.3 16.8-9.6 16.8-1.2 16.9 1.6 16.8-6.3 16.8-.2 16.8-2.8 16.9-2.6 16.8-2.3 16.8-8 16.8-6.3 16.9-4 16.8-7.7L401 116l16.8-2.8 16.9-.7 16.8-1.9 16.8-8.4 16.8-8.2 16.9-8 16.8-7.7 16.8.2 16.8 27.6 16.9-.5 16.8-6.6 16.8-7.3 16.8-10.1 16.9-6.3H654l16.8-6.1 16.8-6.6 16.9-5.8",
  opacity: 0.6
}), React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 2.867,
  opacity: 0.8
}, React.createElement("path", {
  d: "M115 280.8l.4-.2"
}), React.createElement("path", {
  strokeDasharray: ".9542,.9542",
  d: "M116.3 280.3l15.5-6.5 16.9-2.8 16.8-1.9 16.9-5.6 16.8-1.2 16.8-.2 16.9-.7 16.8-5.6 16.9-3.8 16.8-4.9 16.9-4.9 16.8-4.9 16.8-7.7 16.9-13.1 16.9-11.7 16.8-11 16.8-11.7 16.8-6.1 16.9-12.2 16.8-7.2 16.9-8 16.8-10.1 16.9-5.1 16.8-5.8 16.8-10.8 16.9 5.8 16.9-2.8 16.8-13.3 16.8-8.4 16.8-14.3 16.9-6.6L654 74l16.8-12 16.8-14.9 16.9-15.3"
})), React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.867,
  d: "M115 288.3l16.8-3 16.8-3.7 16.9-2.6 16.8-7 16.8-5.8 16.8-9.6 16.9-4.7 16.8-11.9 16.8-8.7 16.8-8 16.9-2.6 16.8-4.4 16.8-3 16.8-4.2 16.9-4.4 16.8-8.9 16.8-7.7 16.8.9 16.9-4.4 16.8-3.5 16.8-9.1 16.8 1.4 16.9 4.9 16.8 1.9 16.8.2 16.8 6.8 16.9-7.5 16.8-1.9 16.8-.2 16.8-3.3 16.9-.5L654 172l16.8-4.4 16.8-4.4 16.9-3.7",
  opacity: 0.6
}), React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.867,
  d: "M115 261.2l16.8-2.8 16.8-.7 16.9-3 16.8-5.8 16.8.7H216l16.9-1.2 16.8-.7 16.8-3.5 16.8-8.9 16.9-9.1L317 218l16.8-13.3 16.8-10.8 16.9-9.4 16.8-4 16.8-4.2 16.8-3.5 16.9-3 16.8-4.2 16.8-2.3 16.8-3.5 16.9 2.1 16.8-2.3 16.8 2.1 16.8 4.4 16.9-3.7 16.8-8 16.8-2.6 16.8-6.8 16.9-6.6 16.8-1.4 16.8-4.9 16.8-4.4L704 123"
}), React.createElement("path", {
  stroke: "#fb7d74",
  strokeWidth: 2,
  d: "M115.1 195.9l16.8-5.6 16.8-8.5 16.9 6.1 16.8 3.2 16.8.8 16.8 2.6 16.9 1.1 16.8-1.6 16.8-1.2 16.8-2.4 16.9-2.8 16.8-3.8 16.8-6.9 16.8-6.1 16.9-5.8 16.8-6.9 16.8-7.4 16.8-3.5 16.9-7.1 16.8-5.8 16.8-7.1 16.8-4.5 16.9-4.9 16.8-4 16.8.7 16.8 13.8 16.9-5.5 16.8-5.5 16.8-5.7 16.8-12.7 16.9-7.1 16.8 24 16.8-5.4 16.8-6.9 16.9-4.3"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Labels",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, React.createElement("text", {
  fill: "#fff",
  transform: "translate(717.116 12.893)"
}, "Houston"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(717.233 35.866)"
}, "Austin"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(717.116 61.59)"
}, "DFW"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(717.115 127.871)"
}, "San Antonio"), React.createElement("text", {
  fill: "#fff",
  transform: "translate(717.116 164.77)"
}, "El Paso"), React.createElement("text", {
  fill: "#fb7d74",
  transform: "translate(718.523 105.893)"
}, "U.S."));

var SvgS7DesktopColors = function SvgS7DesktopColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Viz",
    x: 0,
    y: 0,
    viewBox: "0 0 800 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,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";
export { SvgS7DesktopColors as ReactComponent };